/*** NOTE: className = 'svg-icon' will cause conlift with calcite, disablin g all pointer-event ***/

import React from 'react';

export default {
	checkboxChecked: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M2 2v28h28V2H2zm24 24H6V6h20v20zm-13.008-2.854L8.002 17.8l2-2 2.976 3.119 8.901-8.9L24 12.14 12.992 23.146z" />
		</svg>
	),
	checkboxUnchecked: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M2 2v28h28V2H2zm24 24H6V6h20v20z" />
		</svg>
	),
	checkMark: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path fill="#5a9359" d="M11.927 22l-6.882-6.883-3 3L11.927 28 31.204 8.728l-3.001-3.001z" />
		</svg>
	),
	close: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M18.404 16l9.9 9.9-2.404 2.404-9.9-9.9-9.9 9.9L3.696 25.9l9.9-9.9-9.9-9.898L6.1 3.698l9.9 9.899 9.9-9.9 2.404 2.406-9.9 9.898z" />
		</svg>
	),
	description: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M31.297 16.047c0 8.428-6.826 15.25-15.25 15.25S.797 24.475.797 16.047c0-8.424 6.826-15.25 15.25-15.25s15.25 6.826 15.25 15.25zM18 24V12h-4v12h-2v2h8v-2h-2zm0-18h-4v4h4V6z" />
		</svg>
	),
	edit: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M27.443 9.439l-4.955-4.953 1.652-1.65a2.337 2.337 0 0 1 3.301 0l1.648 1.65a2.33 2.33 0 0 1 .004 3.299l-1.65 1.654zM4.924 22.195l-2.373 7.254 7.328-2.301-4.955-4.953zM20.455 6.713L7.379 19.555l4.951 4.949 13.074-12.842-4.949-4.949z" />
		</svg>
	),
	globe: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M29.998 28.119L21.882 20H28v-2H18v10h2v-6.113l8.115 8.115zM20 16h3.107l1.057-.313c-.246-.963-1.199-2.119-1.199-2.119s1.107.702 1.737.518c.622-.182.156-.933.674-1.477.085-.09.327-.128.506-.126.284.955.439 1.966.439 3.014 0 .17-.014.336-.024.503h2.799c.005-.072.012-.143.012-.216 0-7.365-5.97-13.335-13.335-13.335S2.438 8.419 2.438 15.784s5.97 13.335 13.335 13.335c.077 0 .152-.007.228-.011v-1.795l-.219-1.268h-.008c-2.14 0-4.125-.645-5.787-1.741.028-.885.453-1.697 1.539-3.293.854-1.256.016-2.521-.658-2.961s-1.363-1.192-3.281-1.633c-.551-.127-1.906-.376-2.36-.882l-.001-.038c0-.818.096-1.613.272-2.377a5.025 5.025 0 0 0 1.476.008c1.011-.156.992-1.192 1.329-2.125S9.97 9.97 10.541 8.881c.383-.732-.273-1.587-.64-2.146a10.503 10.503 0 0 1 5.873-1.786c1.194 0 2.34.201 3.41.566.083.499.135 1.199.012 1.676-.137.53-1.133.788-1.415 1.251s-.617 1.747.145 2.045c.761.299 1.613-.09 2.268.333.803.518 1.425 1.633.907 1.711s-2.048-.363-3.059-.363-3.499 1.814-3.344 3.395c.05.511.135.901.254 1.201.066.248.677.811 1.049.853V16h4z" />
		</svg>
	),
	noticeTriangle: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path
				fill="#de2900"
				d="M28.764 30a2 2 0 0 0 1.789-2.894L17.791 1.579a2 2 0 0 0-3.578 0L1.447 27.106a1.997 1.997 0 0 0 .088 1.945c.363.59 1.008.949 1.701.949h25.527zM3.236 28L16.002 2.473 28.764 28H3.237zM14 11.2a1.2 1.2 0 0 1 1.2-1.2h1.6a1.2 1.2 0 0 1 1.2 1.2v7.6a1.2 1.2 0 0 1-1.2 1.2h-1.6a1.2 1.2 0 0 1-1.2-1.2v-7.6zm4 13.601A1.2 1.2 0 0 1 16.801 26h-1.602A1.2 1.2 0 0 1 14 24.801v-1.602A1.2 1.2 0 0 1 15.199 22h1.602A1.2 1.2 0 0 1 18 23.199v1.602z"
			/>
		</svg>
	),
	plus: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M30 18H18v12h-4V18H2v-4h12V2h4v12h12v4z" />
		</svg>
	),
	search: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M31.607 27.838l-6.133-6.137a1.336 1.336 0 0 0-1.887 0l-.035.035-2.533-2.533-.014.014c3.652-4.556 3.422-11.195-.803-15.42-4.529-4.527-11.875-4.531-16.404 0-4.531 4.531-4.529 11.875 0 16.406 4.205 4.204 10.811 4.455 15.365.848l.004.003-.033.033 2.541 2.54a1.33 1.33 0 0 0 .025 1.848l6.135 6.133a1.33 1.33 0 0 0 1.887 0l1.885-1.883a1.332 1.332 0 0 0 0-1.887zM17.811 17.809a8.213 8.213 0 0 1-11.619 0 8.217 8.217 0 0 1 0-11.622 8.219 8.219 0 0 1 11.619.004 8.216 8.216 0 0 1 0 11.618z" />
		</svg>
	),
	trash: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="esri_react_forms_svg_icon">
			<path d="M20 2V0H10v2H2v4h26V2zM6 32h18l2-24H4l2 24zm14-21c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1s-1-.45-1-1V11zm-6 0c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1s-1-.45-1-1V11zm-6 0c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1s-1-.45-1-1V11z" />
		</svg>
	),
	mapPin: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="svg-icon">
			<path d="M15.999 0C11.214 0 8 1.805 8 6.5v17l7.999 8.5L24 23.5v-17C24 1.805 20.786 0 15.999 0zM16 14.402A4.4 4.4 0 0 1 11.601 10a4.4 4.4 0 1 1 8.798 0A4.4 4.4 0 0 1 16 14.402z" />
		</svg>
	),
	minus: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="svg-icon">
			<path d="M30 18H2v-4h28v4z" />
		</svg>
	),
	upload: (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="svg-icon">
			<path d="M8 20h6v10h4V20h6l-8-8zM27.08 8.793C26.428 4.045 22.596.397 17.951.397c-3.48 0-6.504 2.045-8.082 5.062a5.15 5.15 0 0 0-1.344-.199c-2.563 0-4.471 1.909-4.646 4.326-2.172 1.115-3.68 3.368-3.68 5.972 0 3.537 2.891 6.443 5.801 6.443v-2.4c-1.541 0-3.4-1.803-3.4-4.043 0-1.614.91-3.084 2.375-3.837l1.199-.616.1-1.345c.09-1.236 1.016-2.1 2.252-2.1.193 0 .428.037.717.115l1.861.503.893-1.707c1.217-2.328 3.5-3.774 5.955-3.774 3.354 0 6.256 2.718 6.752 6.323l.203 1.484 1.424.468c1.836.606 3.07 2.33 3.07 4.292 0 2.347-1.859 4.235-3.4 4.235v2.4c2.838 0 5.801-2.936 5.801-6.636 0-3.07-1.982-5.67-4.721-6.571z" />
		</svg>
	),
};
